<template>
<div>
  <form class="ui form" @submit.prevent="search()">
    <h4 class="ui dividing header">検索条件</h4>
    <div class="fields">
      <div class="field">
        <label>ステータス</label>
        <dropdown v-model="searchForm.model.status" :placeholder="'すべて'" @change="search()">
          <option value="">すべて</option>
          <option value="reserved">予約確定</option>
          <option value="closed">実施済み</option>
        </dropdown>
      </div>
      <div class="field">
        <label>実施日</label>
        <datepick v-model="searchForm.model.event_date_from" :placeholder="'開始日'" @change="search()"></datepick>
      </div>
      <div class="field">
        <label>&nbsp;</label>
        <span style="display: inline-block; margin-top: 50%;">〜</span>
      </div>
      <div class="field">
        <label>&nbsp;</label>
        <datepick v-model="searchForm.model.event_date_to" :placeholder="'終了日'" @change="search()"></datepick>
      </div>
      <div class="field">
        <label>実施済み変更日</label>
        <datepick v-model="searchForm.model.change_status_to_closed_at_from" :placeholder="'開始日'" @change="search()"></datepick>
      </div>
      <div class="field">
        <label>&nbsp;</label>
        <span style="display: inline-block; margin-top: 50%;">〜</span>
      </div>
      <div class="field">
        <label>&nbsp;</label>
        <datepick v-model="searchForm.model.change_status_to_closed_at_to" :placeholder="'終了日'" @change="search()"></datepick>
      </div>
    </div>
  </form>

  <div class="search-result" :class="{'loading': searchForm.waiting}">
    <div class="ui vertical centered loader" :class="{'active': searchForm.waiting}"></div>
    <div class="ui horizontal divider header">検索結果</div>
    <div class="relative">
      <pagination :pager="pager" :callback="search"></pagination>
      <div style="display: inline-block; position: absolute; right: 0; bottom: 0;">
        <button @click="openDownloadDialog" type="button" class="ui small yellow button"><i class="download icon"></i>CSVでダウンロードする</button>
      </div>
      <div id="show-download-dialog" class="ui mini modal">
        <i class="close icon"></i>
        <div class="header">予約一覧情報CSVダウンロード</div>
        <div class="content">
          <form class="ui form">
            <div class="two fields">
              <div class="required field">
                <label>開始日</label>
                <datepick v-model="downloadForm.model.begin" :placeholder="'開始日'"></datepick>
              </div>
              <div class="required field">
                <label>終了日</label>
                <datepick v-model="downloadForm.model.end" :placeholder="'終了日'"></datepick>
              </div>
            </div>
          </form>
        </div>
        <div class="actions">
          <button class="ui cancel button">閉じる</button>
          <a :href="reservationDownloadLink" target="_blank">
            <button class="ui positive button">ダウンロードする</button>
          </a>
        </div>
      </div>
    </div>
    <table class="ui compact table">
      <thead>
        <tr>
          <th>まるなげID</th>
          <th>申込日時</th>
          <th>実施日時</th>
          <th>ステータス</th>
          <th class="center aligned">チャット</th>
          <th>成約先店舗名</th>
          <th>請求先企業名</th>
          <th>請求対象</th>
          <th>手数料率</th>
          <th>申込者名</th>
          <th>人数</th>
          <th>コース総額</th>
          <th>宴会総額</th>
          <th>予約依頼番号</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="reservation in reservations" :key="reservation.id">
          <td>{{ reservation.marunage.code }}</td>
          <td>{{ reservation.marunage.created_at | formatDatetime }}</td>
          <td>{{ reservation.event_datetime | formatDatetime }}</td>
          <td>{{ reservation.status_label }}</td>
          <td class="center aligned" style="width: 80px;">
            <a :href="reservation.marunage.chat_url" target="_blank">
              <i class="large comment icon"></i>
            </a>
          </td>
          <td>{{ reservation.shop.name }}</td>
          <td>{{ reservation.shop.company_name || '（未設定）' }}</td>
          <td>{{ reservation.shop.billing_subject || '（未設定）' }}</td>
          <td>{{ reservation.shop.charge_rate }}%</td>
          <td>{{ reservation.marunage.name || reservation.marunage.name_kana }}</td>
          <td>{{ reservation.people }}人</td>
          <td>{{ (reservation.contract && reservation.contract.total_course_price) || '（未設定）' | formatCurrency }}</td>
          <td>{{ (reservation.contract && reservation.contract.total_price) || '（未設定）' | formatCurrency }}</td>
          <td>
            <a v-if="reservation.reservation" :href="reservation.reservation.banquet.chat_url" target="_blank"
               :title="reservation.reservation.banquet.shop.name">
              {{ reservation.reservation.id }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
export default {
    data: function() {
        let form = this.createForm(this.query());
        form.model.event_date_from = form.model.event_date_from || moment().startOf('month').format('YYYY/MM/DD');
        form.model.event_date_to = form.model.event_date_to || moment().endOf('month').format('YYYY/MM/DD');

        return {
            searchForm: form,
            pager: this.createPager(30, this.query().offset),
            reservations: [],
            downloadForm: this.createForm(),
        };
    },
    created: function() {
        this.search(this.pager.current());
    },
    computed: {
        reservationDownloadLink: function() {
            let baseUrl = '/afadmin/reservations/download?';
            let filters = [];
            if (this.downloadForm.model.begin) {
                filters.push('begin=' + moment(this.downloadForm.model.begin).format('YYYY-MM-DD'));
            }
            if (this.downloadForm.model.end) {
                filters.push('end=' + moment(this.downloadForm.model.end).format('YYYY-MM-DD'));
            }
            if (filters.length > 0) {
                baseUrl += filters.join('&');
            }
            return baseUrl;
        }
    },
    methods: {
        search: function(opt_position) {
            let position = opt_position || this.pager.first();
            this.merge(this.searchForm.model, position);
            this.replaceStateQuery(this.searchForm.model, ['limit']);
            return this.searchForm.get('/afadmin/api/reservations', function(response) {
                this.reservations = response.data;
                this.pager.update(response.data, response);
            }.bind(this));
        },
        openDownloadDialog: function() {
            $('#show-download-dialog').modal('show');
        }
    }
};
</script>
